import settings from './settings'

export default {
    install(Vue, options) {
        Vue.djangows = {
            callBackList: {
                onmessage: [],
                onmodelsignals: {},
                onnotification: []
            },

            onmodelsignals(options, cb) {
                let key
                if (options.pk !== undefined && options.pk !== null) {
                    key = options.appLabel + "." + options.modelName + "." + options.pk
                } else {
                    key = options.appLabel + "." + options.modelName
                }
                if (!Vue.djangows.callBackList.onmodelsignals[key]) {
                    Vue.djangows.callBackList.onmodelsignals[key] = []
                }
                Vue.djangows.callBackList.onmodelsignals[key].push(cb)
            }
        }

        function init() {
            const ws = new WebSocket(settings.websocketUrl)

            ws.onmessage = (data) => {
// callbacks globaux
                for (let cb of Vue.djangows.callBackList.onmessage) {
                    cb(data)
                }

                const jsonData = JSON.parse(data.data)

// message de type notification (NotificationSerializer) encapsulé dans un signal post_save
                if (jsonData.model === "notification" && jsonData.app === "core") {
                    for (let cb of Vue.djangows.callBackList.onnotification) {
                        cb(jsonData.obj, jsonData.created)
                    }
                    return
                }

                let key = jsonData.app + "." + jsonData.model

// callbacks sur le modèle
                if (Vue.djangows.callBackList.onmodelsignals[key]) {
                    for (let cb of Vue.djangows.callBackList.onmodelsignals[key]) {
                        cb(jsonData)
                    }
                }

// callbacks sur le modèle + pk
                if (jsonData.pk !== undefined && jsonData.pk !== null) {
                    key += "." + jsonData.pk
                    if (Vue.djangows.callBackList.onmodelsignals[key]) {
                        for (let cb of Vue.djangows.callBackList.onmodelsignals[key]) {
                            cb(jsonData)
                        }
                    }
                }
            }

            ws.onopen = (evt) => {
// console.log("ws opened")
            }

            ws.onclose = (evt) => {
// console.log("websocket onclose", evt)
                setTimeout(() => {
                    Vue.djangows["socket"] = init()
                }, 2000)
            }

            ws.onerror = (evt) => {
// console.log("websocket onerror", evt)
            }

            return ws
        }

        Vue.djangows["socket"] = init()

        Vue.mixin({
            created() {
                this.$djangows = {}
                this.$djangows['callbacks'] = []
                const vm = this

                this.$djangows['onmessage'] = (cb) => {
                    Vue.djangows.callBackList.onmessage.push(cb)
                    vm.$djangows['callbacks'].push(cb)
                }

                this.$djangows['onmodelsignals'] = (options, cb) => {
                    let key
                    if (options.pk !== undefined && options.pk !== null) {
                        key = options.appLabel + "." + options.modelName + "." + options.pk
                    } else {
                        key = options.appLabel + "." + options.modelName
                    }
                    if (!Vue.djangows.callBackList.onmodelsignals[key]) {
                        Vue.djangows.callBackList.onmodelsignals[key] = []
                    }
                    Vue.djangows.callBackList.onmodelsignals[key].push(cb)
                    vm.$djangows['callbacks'].push(cb)
                }

                this.$djangows['onnotification'] = (cb) => {
                    Vue.djangows.callBackList.onnotification.push(cb)
                    vm.$djangows['callbacks'].push(cb)
                }
            },

            beforeDestroy() {
// retirer callbacks globaux
                let i = 0
                for (let cb of Vue.djangows.callBackList.onmessage) {
                    for (let localCb of this.$djangows.callbacks) {
                        if (cb === localCb) {
                            Vue.djangows.callBackList.onmessage.splice(i, 1)
                        }
                    }
                    i += 1
                }

// retirer callbacks de notification
                i = 0
                for (let cb of Vue.djangows.callBackList.onnotification) {
                    if (this.$djangows.callbacks.indexOf(cb) >= 0) {
                        Vue.djangows.callBackList.onnotification.splice(i, 1)
                    }
                    i += 1
                }

// retirer callbacks sur modèles
                for (let key in Vue.djangows.callBackList.onmodelsignals) {
                    const cbs = Vue.djangows.callBackList.onmodelsignals[key]
                    let i = 0
                    for (let cb of cbs) {
                        if (this.$djangows.callbacks.indexOf(cb) >= 0) {
                            Vue.djangows.callBackList.onmodelsignals[key].splice(i, 1)
                        }
                        i += 1
                    }
                }

// retirer callbacks liés à des DataHolder
                for (let key in this) {
                    const val = this[key]
                    if (val && typeof val === "object" && Object.prototype.hasOwnProperty.call(val, "_isDataHolder")) {
                        for (let key2 in Vue.djangows.callBackList.onmodelsignals) {
                            const cbs = Vue.djangows.callBackList.onmodelsignals[key2]
                            let i = 0
                            for (let cb of cbs) {
                                if (cb === val.cb) {
                                    Vue.djangows.callBackList.onmodelsignals[key2].splice(i, 1)
                                }
                                i += 1
                            }
                        }
                    }
                }
            }
        })
    }
}
